export function syncDocumentLanguage(language: string | undefined) {
  if (typeof document === "undefined" || !language) return;
  document.documentElement.lang = language;
}
